import type { ThemeConfig } from "antd";

// Restrained, dense admin-tool palette. One accent (CloudFuze blue),
// neutral grays for structure, semantic colors only for status signals.
export const brand = {
  primary: "#0129ac",
  primaryHover: "#011878",
  primarySoft: "#eef1fb",

  bg: "#f7f8fa",
  surface: "#ffffff",
  border: "#e6e8ec",
  borderStrong: "#d6d9de",
  divider: "#eceef1",

  text: "#111827",
  textSecondary: "#5b6470",
  textMuted: "#8b93a1",

  success: "#16a34a",
  successSoft: "#ecfdf3",
  warning: "#b45309",
  warningSoft: "#fff7ed",
  danger: "#b42318",
  dangerSoft: "#fef2f2",
  neutralSoft: "#f1f3f5",
};

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: brand.primary,
    colorLink: brand.primary,
    colorLinkHover: brand.primaryHover,
    colorBgLayout: brand.bg,
    colorBgContainer: brand.surface,
    colorBorder: brand.border,
    colorBorderSecondary: brand.divider,
    colorText: brand.text,
    colorTextSecondary: brand.textSecondary,
    colorTextTertiary: brand.textMuted,
    colorSuccess: brand.success,
    colorWarning: brand.warning,
    colorError: brand.danger,
    borderRadius: 6,
    borderRadiusLG: 8,
    borderRadiusSM: 4,
    fontFamily:
      'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    fontSizeHeading1: 28,
    fontSizeHeading2: 22,
    fontSizeHeading3: 18,
    fontSizeHeading4: 16,
    controlHeight: 34,
    controlHeightSM: 28,
    controlHeightLG: 40,
    wireframe: false,
    motionDurationMid: "0.15s",
    motionDurationSlow: "0.2s",
  },
  components: {
    Layout: {
      headerBg: brand.surface,
      headerHeight: 52,
      headerPadding: "0 20px",
      siderBg: brand.surface,
      bodyBg: brand.bg,
    },
    Menu: {
      itemHeight: 36,
      itemBorderRadius: 6,
      itemMarginInline: 8,
      itemSelectedBg: brand.primarySoft,
      itemSelectedColor: brand.primary,
      itemHoverBg: brand.neutralSoft,
      itemColor: brand.textSecondary,
      iconSize: 16,
      fontSize: 13,
    },
    Button: {
      fontWeight: 500,
      primaryShadow: "none",
      defaultShadow: "none",
      dangerShadow: "none",
    },
    Table: {
      headerBg: "#fafbfc",
      headerColor: brand.textSecondary,
      headerSplitColor: brand.divider,
      rowHoverBg: "#fafbfc",
      cellPaddingBlock: 11,
      cellPaddingInline: 14,
      fontSize: 13,
      headerBorderRadius: 0,
    },
    Card: {
      headerBg: "transparent",
      headerFontSize: 15,
      paddingLG: 20,
    },
    Tag: {
      defaultBg: brand.neutralSoft,
      defaultColor: brand.textSecondary,
    },
    Input: {
      activeShadow: "0 0 0 3px rgba(1, 41, 172, 0.12)",
    },
    Select: {
      optionSelectedBg: brand.primarySoft,
    },
    Modal: {
      titleFontSize: 16,
    },
    Drawer: {
      paddingLG: 20,
    },
    Tabs: {
      titleFontSize: 13,
      horizontalMargin: "0 0 16px 0",
    },
    Form: {
      labelFontSize: 13,
      verticalLabelPadding: "0 0 4px",
    },
  },
};
